<template>
  <div class="tab-content">
      <div class="pagenamPT">
        <h3 class="pagename2">{{ $t(PARTNER_LEVEL_NAME[partnerLevel]) }} {{ $t('front.common.allList') }}</h3>
      </div>
      <div class="partnerTop">
        <div class="select">
          <a @click="partnerListOrder = 'JOIN_DESC'">{{ $t('front.common.latest') }}</a>
          <a @click="partnerListOrder = 'ID_DESC'">{{ $t('front.common.byID') }}</a>
          <a @click="partnerListOrder = 'CASH_DESC'">{{ $t('front.common.byMoney') }}</a>
          <a @click="partnerListOrder = 'POINT_DESC'">{{ $t('front.common.byRolling') }}</a>
        </div>
        <div class="fx-center-end">
          <select class="selectBox" v-model="searchType">
            <option :value="'id'">{{ $t('front.common.memId') }}</option>
            <option :value="'nickname'">{{ $t('front.common.nickName') }}</option>
          </select>
          <input type="text" class="input" v-model="searchValue"/>
          <button class="dateBtn" @click="loadSubList(1)">{{ $t('front.give.search') }}</button>
        </div>
      </div>
      <div class="strTableWrap">
        <div class="strTablescr">
          <div class="strTablePC">
            <table class="strTablePT">
              <colgroup>
                <col style="width:9%;">
                <col style="width:6%;">
                <col style="width:10%;">
                <col style="width:9%;">
                <col style="width:6%;">
                <col style="width:9%;">
                <col style="width:9%;">
                <col style="width:9%;">
                <col style="width:9%;">
                <col style="width:6%;">
                <col style="width:9%;">
                <col style="width:9%;">
              </colgroup>
              <thead>
                <tr>
                  <th>{{ $t('front.common.memId') }}<br />{{ $t('front.common.nickName') }}</th>
                  <th>{{ $t('front.common.partnerRank') }}</th>
                  <th>{{ $t('front.common.department') }}</th>
                  <th>{{ $t('front.cash.nav3') }}<br />{{ $t('front.cash.nav4') }}</th>
                  <th>{{ $t('front.stributor.dnws') }}</th>
                  <th>{{ $t('front.stributor.roll') }} % ({{ $t('front.gnb.casino') }})<br />{{ $t('front.stributor.roll') }} % ({{ $t('front.gnb.slot') }})</th>
                  <th>{{ $t('front.stributor.lose') }} % ({{ $t('front.gnb.casino') }})<br />{{ $t('front.stributor.lose') }} % ({{ $t('front.gnb.slot') }})</th>
                  <th>{{ $t('front.common.moneySum') }}<br />{{ $t('front.common.rollSum') }}</th>
                  <th>{{ $t('front.common.numLowerPart') }}</th>
                  <th>{{ $t('front.stributor.on') }}</th>
                  <th>{{ $t('front.board.regDate') }}</th>
                  <th>{{ $t('front.common.details') }}</th>
                </tr>
              </thead>
              <tbody>
                <template v-if="partnerSubList && partnerSubList.length > 0">
                  <tr v-for="(partner, index) in partnerSubList" :key="partner.memId">
                    <td>
                      {{partner.memId}}<br />
                      <span class="nick">{{partner.memNick}}</span>
                    </td>
                    <td>
                      <span class="box" :class="partner.partnerLevel">{{partner.partnerLevelName}}</span>
                    </td>
                    <td>
                      <div class="topwrap" v-if="partner.topUserList && partner.topUserList.length > 0 && partner.topUserList !== '0'">
                        <select class="h20 upperUser">
                          <option v-for="pt in partner.topUserList" :key="pt.recommenderId">
                            <span>[{{pt.partnerLevelName}}] </span>
                            <span>{{pt.recommenderId}}</span>
                          </option>
                        </select>
                        <i class="icon">+</i>
                      </div>
                      <div v-else>
                        -
                      </div>
                    </td>
                    <td>
                      <div class="twoline-wrap">
                        <span>{{thousand(partner.cashAmt || 0)}}</span>
                        <span>{{thousand(partner.pointAmt || 0)}}</span>
                      </div>
                    </td>
                    <td>
                      <div class="btn-input-wrap">
                        <a class="inout-btn btn-green" @click="onOpenPay(partner, index)">{{ $t('front.give.give') }}{{ $t('front.give.back') }}</a>
                      </div>
                    </td>
                    <td>
                      <div class="btn-input-wrap">
                        <span class="rate-font roboto">{{partner.casinoRate}}%/{{partner.slotRate}}%</span>
                        <a class="plus-btn" @click="onOpenRate(partner, index)"></a>
                      </div>
                    </td>
                    <td>
                      <div class="btn-input-wrap">
                        <span class="rate-font roboto">{{partner.casinoLosing}}%/{{partner.slotLosing}}%</span>
                        <a class="plus-btn" @click="onOpenRate(partner, index)"></a>
                      </div>
                    </td>
                    <td>
                      <div class="twoline-wrap">
                        <span>{{thousand(partner.totalBalance.totalCashAmt || 0)}}</span>
                        <span class="plusAmt minusAmt">{{thousand(partner.totalBalance.totalPointAmt || 0)}}</span>
                      </div>
                    </td>
                    <td>
                      <div class="twoline-wrap f-center">
                        <template v-for="pt in partner.countInfo" :key="pt.partnerLevel">
                          <template v-if="pt.partnerLevel !== 'NORMAL'">
                            <span>{{pt.partnerLevelName}} : {{thousand(pt.cnt || 0)}}</span>
                          </template>
                        </template>
                      </div>
                    </td>
                    <td>
                      <template v-for="pt in partner.countInfo" :key="pt.partnerLevel">
                        <template v-if="pt.partnerLevel == 'NORMAL'">
                          <span>{{thousand(pt.cnt || 0)}}</span>
                        </template>
                      </template>
                    </td>
                    <td>{{partner.joinDate.replace('T', ' ')}}</td>
                    <td>
                      <div class="btn-input-wrap">
                        <a class="btnp" @click="goToDetail(partner.memId)">{{ $t('front.common.partnerInfo') }} / {{ $t('front.board.re') }}</a>
                      </div>
                    </td>
                  </tr>
                </template>
                <tr v-else>
                  <td colspan="12">하부 파트너가 없습니다.</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="partnerCardM">
            <template v-if="partnerSubList && partnerSubList.length > 0">
              <div class="partnerCard" v-for="(partner, index) in partnerSubList" :key="partner.memId">
                <div class="partnerCardHead">
                  <div>
                    <strong>{{ partner.memId }}</strong>
                    <span>{{ partner.memNick }}</span>
                  </div>
                  <span class="box" :class="partner.partnerLevel">
                    {{ partner.partnerLevelName }}
                  </span>
                </div>

                <div class="partnerCardBody">
                  <div class="row">
                    <em>소속</em>
                    <div class="topwrap" v-if="partner.topUserList && partner.topUserList.length > 0 && partner.topUserList !== '0'">
                      <select class="h20 upperUser mw-auto">
                        <option v-for="pt in partner.topUserList" :key="pt.recommenderId">
                          [{{pt.partnerLevelName}}] {{pt.recommenderId}}
                        </option>
                      </select>
                      <i class="icon">+</i>
                    </div>
                    <span v-else>-</span>
                  </div>

                  <div class="row">
                    <em>보유머니</em>
                    <span>{{ thousand(partner.cashAmt || 0) }}</span>
                  </div>

                  <div class="row">
                    <em>보유포인트</em>
                    <span>{{ thousand(partner.pointAmt || 0) }}</span>
                  </div>

                  <div class="row">
                    <em>입출금</em>
                    <div class="btns">
                      <a class="inout-btn btn-green" @click="onOpenPay(partner, index)">
                        지급회수
                      </a>
                    </div>
                  </div>

                  <div class="row">
                    <em>롤링</em>
                    <span>{{ partner.casinoRate }}% / {{ partner.slotRate }}%</span>
                    <a class="plus-btn" @click="onOpenRate(partner, index)"></a>
                  </div>

                  <div class="row">
                    <em>루징</em>
                    <span>{{ partner.casinoLosing }}% / {{ partner.slotLosing }}%</span>
                    <a class="plus-btn" @click="onOpenRate(partner, index)"></a>
                  </div>

                  <div class="row">
                    <em>총보유머니</em>
                    <span>{{ thousand(partner.totalBalance.totalCashAmt || 0) }}</span>
                  </div>

                  <div class="row">
                    <em>총보유롤링금</em>
                    <span class="plusAmt minusAmt">
                      {{ thousand(partner.totalBalance.totalPointAmt || 0) }}
                    </span>
                  </div>

                  <div class="row">
                    <em>하부수</em>
                    <span>
                      <template v-for="pt in partner.countInfo" :key="pt.partnerLevel">
                        <template v-if="pt.partnerLevel !== 'NORMAL'">
                          {{ pt.partnerLevelName }} : {{ thousand(pt.cnt || 0) }}
                        </template>
                      </template>
                    </span>
                  </div>

                  <div class="row">
                    <em>회원수</em>
                    <span>
                      <template v-for="pt in partner.countInfo" :key="pt.partnerLevel">
                        <template v-if="pt.partnerLevel == 'NORMAL'">
                          {{ thousand(pt.cnt || 0) }}
                        </template>
                      </template>
                    </span>
                  </div>

                  <div class="row">
                    <em>등록일시</em>
                    <span>{{ partner.joinDate.replace('T', ' ') }}</span>
                  </div>
                </div>

                <a class="partnerCardBtn" @click="goToDetail(partner.memId)">
                  파트너정보 / 수정
                </a>
              </div>
            </template>

            <div class="partnerCardEmpty" v-else>
              하부 파트너가 없습니다.
            </div>
          </div>
        </div>
      </div>
    <pagination v-if="pageInfo"
                :pageNum="pageInfo.page"
                :pageSize="pageInfo.count_per_list"
                :totalCount="pageInfo.tatal_list_count"
                @goToPage="loadSubList"
    />
      <transition name="fade">
        <RateTable v-if="RateOpen" :selectMem="selectMem" :selectIdx="selectIdx"  @close="onCloseRate"/>
      </transition>
      <transition name="fade">
        <Paymodal v-if="PayMopen" :selectMem="selectMem" :selectIdx="selectIdx" @close="onClosePay"/>
      </transition>
  </div>
</template>

<script>
import RateTable from '@/components/common/RateTable.vue'
import Paymodal from '@/components/common/Pay.vue'
import Pagination from '@/components/ui/Pagination.vue'
import { mapState } from 'vuex'
import { getPartnerListV2 } from '@/api/v2/partner'
import { thousand } from '@/libs/utils'
import { PARTNER_LEVEL_NAME, PARTNER_LEVEL_ORDER } from '@/libs/constants'
export default {
  name: 'partnerListLevel',
  components: { Pagination, RateTable, Paymodal },
  computed: {
    ...mapState([
      'userData',
      'gameCount',
      'commonCodeByOrder',
      'commonCodeByCode'
    ]),
    PARTNER_LEVEL_NAME () {
      return PARTNER_LEVEL_NAME
    }
  },
  data () {
    return {
      RateOpen: false,
      PayMopen: false,
      selectMem: null,
      selectIdx: null,
      selectedLi: null,
      partnerLevel: null,
      partnerSubList: null,
      partnerListOrder: 'JOIN_DESC',
      searchType: 'id',
      searchValue: ''
    }
  },
  async created () {
    const name = this.$route.name
    this.partnerLevel = name.replace('partnerListLevel', '')
    await this.loadSubList(1)
  },
  watch: {
    partnerListOrder () {
      this.loadSubList(1)
    }
  },
  methods: {
    goToDetail (memId) {
      // this.goPageByName('partnerDetail', { memId: memId })
      this.detailOpen('partner', memId)
    },
    onCloseRate () {
      this.RateOpen = false
      this.selectMem = null
      this.selectIdx = null
    },
    onClosePay (newCash, idx) {
      if (newCash !== null && newCash !== undefined) {
        this.partnerSubList[idx].cashAmt = newCash
      }
      this.PayMopen = false
      this.selectMem = null
      this.selectIdx = null
    },
    onOpenPay (selectMem, selectIdx) {
      this.selectMem = {
        ...selectMem,
        cashAmt: thousand(selectMem.cashAmt)
      }
      this.selectIdx = selectIdx
      this.PayMopen = true
    },
    onOpenRate (selectMem, selectIdx) {
      this.selectMem = {
        ...selectMem,
        cashAmt: thousand(selectMem.cashAmt)
      }
      this.selectIdx = selectIdx
      this.RateOpen = true
    },
    async loadSubList (page) {
      if (!page) {
        page = this.pageInfo.page
      } else {
        this.pageInfo.page = page
      }
      this.emitter.emit('Loading', true)

      const params = {
        memId: this.userData.memId,
        targetLevel: this.partnerLevel,
        searchType: this.searchType,
        searchValue: this.searchValue,
        orderStr: this.partnerListOrder,
        page: page,
        count_per_list: 40
      }

      await getPartnerListV2(params).then(res => {
        this.emitter.emit('Loading', false)
        const result = res.data
        if (result.resultCode === '0') {
          this.partnerSubList = result.data.list

          this.partnerSubList.forEach(item => {
            const topUserList = []
            if (item.topUserList) {
              item.topUserList.forEach(pt => {
                if (this.userData.partnerLevelOrder <= PARTNER_LEVEL_ORDER[pt.partnerLevel]) {
                  topUserList.push(pt)
                }
              })
            }
            item.topUserList = topUserList
          })
        }

        if (result.data.pageInfo) {
          this.pageInfo = result.data.pageInfo
        } else {
          this.pageInfo.page = 1
          this.pageInfo.tatal_list_count = 0
        }
      })
    }
  }
}
</script>

<style src="@/styles/striNew.css"></style>
<style scoped>
/* ================= 화이트 버전 기본 레이아웃 ================= */
.tab-content {
  min-height: calc(100vh - 55px);
  padding: 18px 18px 42px;
  background: #f4f7fb;
  color: #172033;
  box-sizing: border-box;
}

.pagenamPT {
  display: flex;
  align-items: center;
  min-height: 34px;
  margin: 0 0 14px;
}

.pagename2 {
  position: relative;
  margin: 0;
  padding-left: 12px;
  color: #172033;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.2;
}

.pagename2::before {
  content: '';
  position: absolute;
  left: 0;
  top: 2px;
  width: 4px;
  height: 18px;
  border-radius: 3px;
  background: #2f7df6;
}

.partnerTop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin: 0 0 16px;
  padding: 14px 16px;
  border: 1px solid #e1e7f0;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 8px 20px rgba(20, 35, 58, 0.06);
  box-sizing: border-box;
}

.strTableWrap {
  width: 100%;
  background: transparent;
  box-sizing: border-box;
}

.strTablescr {
  width: 100%;
  padding: 14px;
  border: 1px solid #e1e7f0;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 8px 20px rgba(20, 35, 58, 0.06);
  box-sizing: border-box;
  overflow: visible;
}

.strTablescr > div {
  width: 100%;
}

/* ================= 검색 / 정렬 영역 ================= */
.select {
  display: flex;
  align-items: center;
  gap: 6px;
}

.select a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  padding: 0 13px;
  border: 1px solid #d7deea;
  border-radius: 6px;
  background: #fff;
  color: #536071;
  font-size: 13px;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  box-sizing: border-box;
  transition: 0.15s ease;
}

.select a.on,
.select a:hover {
  border-color: #2f7df6;
  background: #2f7df6;
  color: #fff;
}

.fx-center-end {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  min-width: 0;
}

.selectBox,
.input {
  height: 36px !important;
  border: 1px solid #d7deea !important;
  border-radius: 7px !important;
  background: #fff !important;
  color: #172033 !important;
  font-size: 13px !important;
  font-weight: 700;
  box-sizing: border-box;
  outline: none;
}

.selectBox {
  min-width: 96px;
  padding: 0 10px !important;
}

.input {
  width: 300px;
  padding: 0 12px !important;
}

.selectBox:focus,
.input:focus {
  border-color: #2f7df6 !important;
  box-shadow: 0 0 0 3px rgba(47, 125, 246, 0.12);
}

.dateBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  min-width: 64px;
  padding: 0 14px;
  border: 0;
  border-radius: 7px;
  background: #2f7df6;
  color: #fff;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
  box-sizing: border-box;
}

.dateBtn:hover {
  filter: brightness(0.96);
}

/* ================= 버튼 / 공통 요소 ================= */
.btnp,
.inout-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  box-sizing: border-box;
}

.btnp {
  min-height: 28px;
  padding: 0 12px;
  border-radius: 6px;
  background: #6f61d8;
  color: #fff;
  font-size: 12px;
  font-weight: 800;
  box-shadow: none;
}

.btnp:hover,
.partnerCardBtn:hover {
  filter: brightness(0.96);
}

.inout-btn {
  min-width: 58px;
  min-height: 28px;
  padding: 0 8px;
  border-radius: 6px;
  background: #2f7df6;
  color: #fff;
  font-size: 11px;
  font-weight: 800;
  box-shadow: none;
}

.btn-green {
  background: #10a66a !important;
}

.btn-orange {
  background: #f59f00 !important;
}

.btn-input-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.twoline-wrap {
  display: flex;
  flex-direction: column;
  gap: 5px;
  line-height: 1.2;
}

.f-center {
  align-items: center;
}

.rate-font {
  color: #445165;
  font-size: 12px;
  font-weight: 800;
}

.plus-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 4px;
  background: #6f7784;
  color: #fff;
  cursor: pointer;
  vertical-align: middle;
}

.plus-btn::before {
  content: '+';
  margin-top: -1px;
  font-size: 13px;
  font-weight: 900;
  line-height: 1;
}

.nick,
.plusAmt.minusAmt {
  color: #ff6b00;
  font-weight: 800;
}

.box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 42px;
  height: 23px;
  padding: 0 8px;
  border-radius: 5px;
  background: #e8efff;
  color: #fff;
  font-size: 11px;
  font-weight: 800;
  box-sizing: border-box;
}

.upperUser,
.h20 {
  height: 26px !important;
  border: 1px solid #cfd7e4 !important;
  border-radius: 5px !important;
  background: #fff !important;
  color: #334155 !important;
  font-size: 12px !important;
}

.topwrap {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.topwrap .icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 4px;
  background: #6f7784;
  color: #fff;
  font-size: 13px;
  font-style: normal;
  font-weight: 900;
}

/* ================= 테이블 ================= */
.strTablePC {
  width: 100%;
  overflow-x: auto;
}

.strTablePT {
  width: 100%;
  min-width: 1040px;
  border: 1px solid #dfe6ef;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  color: #172033;
  font-size: 13px;
}

.strTablePT thead th {
  height: 48px;
  padding: 10px 8px;
  border: 0;
  border-bottom: 1px solid #d6dfeb;
  background: #eaf1f9;
  color: #172033;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.35;
  text-align: center;
  white-space: normal;
}

.strTablePT tbody td {
  min-height: 54px;
  padding: 12px 8px;
  border: 0;
  border-bottom: 1px solid #e8edf4;
  background: #fff;
  color: #172033;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  vertical-align: middle;
}

.strTablePT tbody tr:nth-child(even) td {
  background: #fbfcfe;
}

.strTablePT tbody tr:hover td {
  background: #f2f6fb;
}

.strTablePT tbody tr:last-child td {
  border-bottom: 0;
}

.partnerCardM {
  display: none;
}

.subPT_1 li {
  position: relative;
}

.allBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 57px;
  height: 20px;
  border: 0;
  border-radius: 4px;
  background: #ef4444;
  color: #fff;
  font-size: 11px;
  font-weight: 800;
  box-shadow: none;
}

/* ================= 모바일 ================= */
@media (max-width: 1000px) {
  .tab-content {
    padding: 14px 12px 28px;
  }

  .pagename2 {
    font-size: 17px;
  }

  .partnerTop {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    padding: 12px;
  }

  .select {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 7px;
    width: 100%;
  }

  .select a {
    width: 100%;
    height: 36px;
    padding: 0 5px;
    border-radius: 8px;
    font-size: 12px;
  }

  .fx-center-end {
    display: grid;
    grid-template-columns: 96px minmax(0, 1fr) 64px;
    gap: 7px;
    width: 100%;
  }

  .fx-center-end .selectBox,
  .fx-center-end .input,
  .fx-center-end .dateBtn {
    width: 100%;
    min-width: 0;
    height: 38px !important;
    border-radius: 8px !important;
  }

  .fx-center-end .selectBox {
    padding: 0 8px !important;
  }

  .fx-center-end .input {
    padding: 0 10px !important;
  }

  .fx-center-end .dateBtn {
    padding: 0;
  }

  .strTablescr {
    padding: 12px;
    overflow-x: hidden;
    background: transparent;
    border: 0;
    box-shadow: none;
  }

  .strTablescr > div {
    overflow-x: hidden;
    white-space: normal;
  }

  .strTablePC {
    display: none;
  }

  .partnerCardM {
    display: flex;
    flex-direction: column;
    gap: 14px;
    width: 100%;
  }

  .partnerCard {
    overflow: hidden;
    border: 1px solid #e1e7f0;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 6px 16px rgba(20, 35, 58, 0.07);
  }

  .partnerCardHead {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 14px 15px;
    border-bottom: 1px solid #e5ebf3;
    background: #eef3fb;
  }

  .partnerCardHead strong {
    display: block;
    color: #172033;
    font-size: 16px;
    line-height: 1.2;
  }

  .partnerCardHead span:not(.box) {
    display: block;
    margin-top: 4px;
    color: #ff6b00;
    font-size: 13px;
    font-weight: 800;
    line-height: 1.2;
  }

  .partnerCardHead .box {
    flex-shrink: 0;
    width: auto;
    min-width: 42px;
    height: 24px;
    border-radius: 12px;
  }

  .partnerCardBody {
    padding: 6px 14px 4px;
  }

  .partnerCardBody .row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    min-height: 42px;
    padding: 7px 0;
    border-bottom: 1px solid #edf1f6;
    font-size: 13px;
  }

  .partnerCardBody .row em {
    flex: 0 0 105px;
    color: #5f6b7a;
    font-size: 12px;
    font-style: normal;
    font-weight: 800;
    line-height: 1.3;
  }

  .partnerCardBody .row span,
  .partnerCardBody .row > div {
    flex: 1;
    justify-content: flex-end;
    color: #172033;
    font-weight: 700;
    text-align: right;
    word-break: break-all;
  }

  .partnerCardBody .row .plus-btn {
    flex: 0 0 16px;
  }

  .partnerCardBody .topwrap {
    width: 100%;
    max-width: 180px;
    margin-left: auto;
  }

  .partnerCardBody .topwrap select.upperUser {
    height: 28px !important;
    font-size: 11px !important;
  }

  .partnerCardBody .btns {
    display: flex;
    justify-content: flex-end;
    gap: 6px;
  }

  .partnerCardBody .inout-btn {
    width: auto;
    min-width: 62px;
    height: 28px;
    padding: 0 8px;
    font-size: 11px;
    border-radius: 7px;
  }

  .partnerCardBtn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 42px;
    margin: 8px 14px 14px;
    border-radius: 9px;
    background: #5f54d9;
    color: #fff;
    font-size: 14px;
    font-weight: 800;
    cursor: pointer;
  }

  .partnerCardBtn:active {
    transform: scale(0.98);
  }

  .partnerCardEmpty {
    padding: 35px 12px;
    border: 1px solid #e1e7f0;
    border-radius: 12px;
    background: #fff;
    color: #6b737c;
    text-align: center;
    font-size: 14px;
  }
}
</style>
